export default "__VITE_ASSET__603bab88__"